
import React from 'react';

export const UserContext = React.createContext();

export function hasAccountPermission(userContext, permission) {
  return Boolean(userContext?.actions?.hasPerm(permission));
}

export { default as LoginForm } from './Login';
export { default as UserProvider } from './Provider';
